/**
 * Cross-surface URLs for the authenticated apps, derived from the *current* host
 * so they resolve correctly in every environment (dev `lvh.me:3100`, staging,
 * production) instead of hardcoding the production domain.
 *
 * Marketing is served on the apex host; the operator + portal apps live on the
 * `admin.` / `portal.` subdomains of that same host (see config/application.rb
 * host config and CLAUDE.md "Local hosts"). Each app's bare host resolves to its
 * dashboard, which redirects to that app's own login when there's no session — so
 * a single host-relative link is the whole entry point.
 *
 * Marketing renders client-only (no SSR), so `window` is always available; the
 * production fallback only guards non-browser contexts (e.g. unit tests).
 */
const PROD_FALLBACK = {
  portal: 'https://portal.geo4logistics.com',
  admin: 'https://admin.geo4logistics.com',
} as const

export function surfaceUrl(app: 'portal' | 'admin', path = ''): string {
  if (typeof window === 'undefined') return `${PROD_FALLBACK[app]}${path}`
  const { protocol, host } = window.location
  // Marketing also answers on the `www.` host; the apps sit on the apex.
  const apex = host.replace(/^www\./, '')
  return `${protocol}//${app}.${apex}${path}`
}
